import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { LOYALTY_REWARDS } from "../../utils/constant";

const Footer = () => {
  const heading = useSelector((state) => state.header.heading);

  return (
    <footer>
      <p>&copy; 2026 Hero Housing. All rights reserved.</p>
      {/* {heading === LOYALTY_REWARDS ? (
        <Link to="" id="installBtn">
          Install App
        </Link>
      ) : (
        <></>
      )} */}
    </footer>
  );
};

export default Footer;
